import ProductVariantsContainer from './ProductVariantsContainer';

export default ProductVariantsContainer;
